import MedicinesLogCard from "./MedicinesLogCard";

export default MedicinesLogCard;
